<template lang="pug">
  .admin-managers
    .admin-managers__title
      h1.title Операторы
    .admin-managers__content
      .admin-managers__button
        router-link.button.button_paint-main--transparent(
        to="/administrator/operators-create"
        ) Создать учетную запись
      .admin-managers__table
        admin-operators-table(
        :tab_data="operators"
        )
      .admin-managers__pagination
        admin-table-pagination

</template>

<script>
import AdminTablePagination from "../components/admin-table-pagination.vue";
import AdminOperatorsTable from "./components/admin-operators-table.vue";

export default {
  name: "admin-operators",

  components: {
    AdminOperatorsTable,
    AdminTablePagination,
  },
  data() {
    return {
      operators: [
        {
          name: "Султанов Рамиль Рустамович",
          area: "Татарстан",
          id: 1,
        },
        {
          name: "Султанов Рамиль Рустамович",
          area: "Татарстан",
          id: 2,
        },
        {
          name: "Султанов Рамиль Рустамович",
          area: "Татарстан",
          id: 3,
        },
      ],
    };
  },
};
</script>
